import { Avatar, Box, Button, CircularProgress, Divider, ITheme, ListItemIcon, ListItemText, Menu, MenuItem, useTheme } from '@mui/material';
import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LogoutIcon from '@mui/icons-material/Logout';
import LockResetIcon from '@mui/icons-material/LockReset';
import SettingsIcon from '@mui/icons-material/Settings';
import { useAppDispatch, useAppSelector } from '../../store/reducers/store';
import { unauthenticate } from '../../store/actions/authentication';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AUTHENTICATED_ROUTES, UNAUTHENTICATED_ROUTES } from '../../resources/routes-constants';

const UserButton: React.FC = () => {
    const { t } = useTranslation();
    const theme = useTheme() as ITheme;
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const nickname = useAppSelector(state => state.authentication.nickname);
    const authenticating = useAppSelector(state => state.authentication.authenticating);
    const dispatch = useAppDispatch();
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const logout = () => {
        navigate(UNAUTHENTICATED_ROUTES.HOMEPAGE_ROUTE);
        dispatch(unauthenticate());
    }
    const settings = () => {
        navigate(AUTHENTICATED_ROUTES.SETTING_ROUTE);
    }
    function stringAvatar(name: string) {
        return {
            children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
        };
    }
    return <div>
        <Button
            id="user-button"
            aria-controls={open ? 'user-button-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            variant="contained"
            color='info'
            disableElevation
            onClick={handleClick}
            endIcon={<KeyboardArrowDownIcon />}
            startIcon={<Avatar  {...stringAvatar(nickname ? nickname : "")} sx={{ backgroundColor: theme.palette.primary.dark, width: "32px", height: "32px", fontSize: "16px !important"}} />} //<CircleIcon sx={{ fontSize: "32px", width: "32px",  height: "32px"}} />
        >
            {nickname}
        </Button>
        <Menu
            MenuListProps={{
                'aria-labelledby': 'user-button',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
        >
            <MenuItem onClick={logout}
                sx={{ width: "200px" }}>
                <ListItemIcon>
                    <LogoutIcon fontSize="small" />
                </ListItemIcon>
                <Box display={"flex"} justifyContent={"space-between"} width={"100%"}>
                    <ListItemText>{t('BtnSignOutSign')}</ListItemText>
                    {authenticating && <CircularProgress size={"20px"} />}
                </Box>
            </MenuItem>
            <Divider />
            <MenuItem>
                <ListItemIcon>
                    <LockResetIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>{t('BtnChangePassword')}</ListItemText>
            </MenuItem>
            <Divider />
            <MenuItem onClick={settings}>
                <ListItemIcon>
                    <SettingsIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>{t('BtnSettings')}</ListItemText>
            </MenuItem>
        </Menu>
    </div>
}

export default UserButton;